import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextMedium } from 'Packages/FacetDesign/Components/BodyText';
import { FDDialogTitle } from '@facet-wealth/design';

const MissingPrerequisiteStepMetaOverrideSet = buildFacetDesignOverride()
  .nameOverride('remainingAttempts', { hidden: true })
  .nameOverride('title', {
    _component: () => FDDialogTitle,
  }, overrideReadOnly)
  .nameOverride(['primaryText', 'secondaryText'], {
    _component: () => BodyTextMedium,
  }, overrideReadOnly);

export default MissingPrerequisiteStepMetaOverrideSet;
